import { PagePending } from "@/components/ui/PagePending";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { custom, fallback, object, optional, pipe, string } from "valibot";

const isDateString = () =>
  custom<string>(input => (typeof input === "string" ? /^\d{4}-\d{2}-\d{2}$/.test(input) : false));

export const Route = createFileRoute("/supporter/$supporterId/allowance-reports/spend")({
  pendingComponent: PagePending,
  validateSearch: object({
    // Spend report day-precision range (YYYY-MM-DD)
    from: fallback(optional(pipe(string(), isDateString())), undefined),
    to: fallback(optional(pipe(string(), isDateString())), undefined),
  }),
  component: lazyRouteComponent(() => import("./+Spend")),
});
